if(typeof window !== 'undefined')
    $ = window.jQuery = window.$ = require('jquery');

// If operating headless, do not use standard jquery or import ui.
if(typeof window !== 'undefined'){
    var ui_extensions            = require("ui-extensions");
} else {
    var ui_extensions = {}; // keep the interpreter happy, the UI will get stripped from the config anyway.
}

var lib_core                        = require("lib-core");
var lib_geometry                    = require("lib-geometry");
var editor_2d                       = require("editor-2d");
var cio_datamodel                   = require("cio-datamodel");

var GuiMode = require("./../shared/guiMode.js");
var colors = require("./../shared/index.js").colors;

var shared_extensions = require("../shared/index.js");
var extensions = require("./index.js");

var SymbolEditorApp = function(editorOptions, endpoints) {
    var self = this;
    var dataManagerConfig, authConfig, recorderConfig;

    // EDITOR MODE
    var editorMode = parseInt(editorOptions["mode"]);

    if (editorOptions["environment"] == "offline") {
        // SERVICE CONTENT API
        dataManagerConfig = {
            content_server_client: {
                type: "Offline"
            },
            asset_loader: {
                type:             "Dummy",
                datamodel_version: cio_datamodel.datamodel_version
            },
            document_loader: {
                type:         "Empty",
                datamodel: cio_datamodel
            },
            document_options: {
                mode:      editorMode,
                dataClass: cio_datamodel.SymbolData
            }
        };

        // AUTHENTICATION
        authConfig = {auth_required : false};
    } else {

        // SERVICE CONTENT API
        dataManagerConfig = {
            content_server_client: {
                type:         "ContentServer",
                serverurl:    endpoints["contentServer"]["server"],
                tenant:       endpoints["contentServer"]["tenant"],
                assetTypeRouter: {
                    "symbol": "/symbols",
                    "footprint": "/footprints",
                    "package": "/packages",
                    "component": "/components",
                    "circuit": "/circuits",
                    "library": "/libraries",
                    "3dmodel": "/3dmodels"
                }
            },
            asset_loader: {
                type:              "ContentServer",
                datamodel_version: cio_datamodel.datamodel_version
            },
            document_loader: {
                type:      "Static",
                datamodel: cio_datamodel,
                url:       endpoints["collabServer"]
            },
            document_options: {
                readOnly:     editorOptions.mode <= GuiMode.INSPECT,
                creationAllowed: editorOptions.mode >= GuiMode.EDIT,
                id:           editorOptions["assetid"],
                version:      editorOptions["assetversion"],
                hub:          editorOptions["hub"],
                assetType:    "symbol",
                dataClass:    cio_datamodel.SymbolData
            }
        };

        // AUTHENTICATION
        authConfig = {
            auth_required: true,
            env: editorOptions["environment"],
            urls: endpoints
        };

    }

    // EVENT RECORDER
    if(editorMode > GuiMode.VIEW){
        recorderConfig = {
            recording: editorOptions["recording"],
            eventsAPIServer: endpoints["eventsAPI"]["server"],
            eventsAPIAFC: endpoints["eventsAPI"]["AFC"]
        };
    }

    // CREATE CONFIG
    var config = SymbolEditorApp.getConfig(dataManagerConfig, recorderConfig, authConfig, endpoints, editorMode, editorOptions.environment);

    // START EDITOR
    this['buildPromise'] = lib_core.Controller.buildApp(".editor", config);
    this['buildPromise']
        .catch(function(error) {
            logError("Symbol Editor App", error, logError.criticality.CRITICAL, "attempting to build extensions.");
        }).then(function(toplevelController) {
            self.toplevelController = toplevelController;
        });
};

SymbolEditorApp.getConfig = function(dataManagerConfig, recorderConfig, authConfig, endpoints, editorMode, environment){
    // GRID SETTINGS
    var defaultGridValue = 10;

    // ACTUAL CONFIG
    var config = {     //TODO: remove the quotes again for closure compiler
        controller: ui_extensions.LoadingController,
        configuration : {
            icon: "https://123d-circuits-assets.s3.amazonaws.com/editorlogo-symbol.png",
            title: "Symbol",
            description: "Create a symbol to be used in a component.",
            showOnlyLoadingBar: (editorMode <= GuiMode.INSPECT)
        },
        extensions: {
            "error_messages": {
                controller: ui_extensions.ErrorMessageController
            },
            "user": {
                controller: lib_core.UserController,
                configuration : authConfig
            },
            "loading_watchdog": {
                controller: shared_extensions.LoadingWatchdogController,
                disabled: environment == 'local',
                configuration: {
                    timeout: 30*1000
                }
            },
            "app": {
                controller: lib_core.AppController,
                configuration : {
                    dataManagerConfig: dataManagerConfig,
                    recorderConfig: recorderConfig
                },
                extensions: {
                    "master": {
                        controller: ui_extensions.MasterController,
                        configuration : {
                            logoImage: "https://123d-circuits-assets.s3.amazonaws.com/editorlogo-symbol.png",
                            logoLink: endpoints["mainSite"],
                            //readonly: (editorMode === lib_core.GuiMode.VIEW),
                            noNav: (editorMode <= GuiMode.VIEW)
                        },
                        extensions: {
                            // "connection_messages": {
                            //     disabled: (editorMode < GuiMode.EDIT),
                            //     controller: ui_extensions.ConnectionMessageController
                            // },
                            "sidebar": {
                                disabled: (editorMode < GuiMode.EDIT),
                                controller: ui_extensions.SidebarController,
                                extensions: {
                                    "versions": {
                                        controller: ui_extensions.VersionsController
                                    }
                                }
                            },
                            "symbol_tab": {
                                name: "symbol_tab",
                                controller: ui_extensions.TabController,
                                configuration : {
                                    theme: "white",
                                    button: {
                                        name: 'Symbol',
                                        title: '#symbol',
                                        style: {
                                            icon: 'icon-view-schematic.svg'
                                        }
                                    }
                                },
                                extensions: {
                                    "editor": {
                                        controller: editor_2d.Editor2DController,
                                        configuration : {
                                            disableMouse: (editorMode <= GuiMode.RENDER),
                                            disableKeys:(editorMode <= GuiMode.RENDER),
                                            canNotSelect: (editorMode <= GuiMode.VIEW),
                                            coarseness: 10,
                                            layers: [
                                                "MEASURE",
                                                "TERMINAL",
                                                "ELEMENT",
                                                "TEXT",
                                                "INTERACTION",
                                                "SNAP",
                                                "ELEMENTCONTROL",
                                                "TEXTCONTROL",
                                                "MEASURECONTROL",
                                                "INTERACTIONCONTROL"
                                            ],
                                            type: "symbol",
                                            layer_options: [
                                                ["SNAP", {
                                                    'zooms': false
                                                }],
                                                ["ELEMENT", {
                                                    'svg': {
                                                        'fill': colors.symbolBody, // dark red
                                                        'stroke': colors.symbolBody,
                                                        'stroke-width': 1,
                                                        'opacity': 1,
                                                        'stroke-linecap': 'butt',
                                                        'stroke-linejoin': 'butt'
                                                    }
                                                }],
                                                ["ELEMENTCONTROL", {
                                                    'svg': {
                                                        'fill': 'green',    //DO NOT REMOVE
                                                        'stroke': 'green',  //DO NOT REMOVE
                                                        'stroke-width': 2,
                                                        'opacity' : 0
                                                    }
                                                }],
                                                ["TEXT", {
                                                    'svg': {
                                                        'fill': colors.symbolText, 
                                                        'stroke': colors.symbolText,
                                                        'stroke-width': 2,
                                                        'opacity': 1,
                                                        'stroke-linecap': 'butt',
                                                        'stroke-linejoin': 'butt'
                                                    }
                                                }],
                                                ["TEXTCONTROL", {
                                                    'svg': {
                                                        'fill': 'blue',    //DO NOT REMOVE
                                                        'stroke': 'blue',  //DO NOT REMOVE
                                                        'stroke-width': 2,
                                                        'opacity' : 0
                                                    }
                                                }],
                                                ["INTERACTIONCONTROL", {
                                                    'svg': {
                                                        'fill': 'blue',    //DO NOT REMOVE
                                                        'stroke': 'blue',  //DO NOT REMOVE
                                                        'stroke-width': 2,
                                                        'opacity': 0
                                                    }
                                                }],
                                                ["MEASURE", {
                                                    'svg': {
                                                        'fill' : 'grey',
                                                        'stroke' : 'grey',
                                                        'stroke-width' : 2,
                                                        'opacity' : 1
                                                    }
                                                }],
                                                ["MEASURECONTROL", {
                                                    'svg': {
                                                        'fill' : 'grey',
                                                        'stroke' : 'grey',
                                                        'stroke-width' : 2,
                                                        'opacity' : 1
                                                    }
                                                }]
                                            ]
                                        },
                                        extensions: {
                                            "camera": {
                                                controller: editor_2d.Camera2DController,
                                                configuration : {
                                                    defaultWorkPlane: [-195, -195, 390, 390],
                                                    viewSmin: 0.2,
                                                    viewSmax: 10
                                                },
                                                extensions: {
                                                    "panning": {
                                                        controller: editor_2d.PanningController
                                                    },
                                                    "zooming": {
                                                        controller: editor_2d.ZoomingController,
                                                        configuration: {
                                                            noButtons: (editorMode <= GuiMode.VIEW)
                                                        }
                                                    }
                                                }
                                            },
                                            "ui_dragging": {
                                                controller: ui_extensions.DraggingController
                                            },
                                            "selection": {
                                                disabled: (editorMode <= GuiMode.VIEW),
                                                controller: editor_2d.SelectionController,
                                                extensions: {
                                                    "groupSelection": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.GroupSelectionController,
                                                        extensions: {
                                                            "alignment" : {
                                                                controller: editor_2d.AlignmentController,
                                                            }
                                                        }
                                                    },
                                                    "gridSelection": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.SelectionGridController,
                                                        configuration : {
                                                            layers: {
                                                                draw: "ELEMENT",
                                                                control: "ELEMENTCONTROL",
                                                                interaction: "INTERACTION",
                                                                interactionControl: "INTERACTIONCONTROL"
                                                            }
                                                        }
                                                    },
                                                    "moving": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.MovingController,
                                                        extensions: {
                                                        }
                                                    },
                                                    "flip": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.FlipController,
                                                        configuration : {
                                                            states: ["moving"]
                                                        }
                                                    },
                                                    "rotate" : {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.RotateController,
                                                        configuration : {
                                                            rotateAngle: 90,
                                                            states: ["moving"]
                                                        }
                                                    },
                                                    "delete" : {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.DeleteController
                                                    },
                                                    "inspector": {
                                                        controller: ui_extensions.InspectorController,
                                                        configuration : {
                                                            draggable: true,
                                                            read_only: (editorMode < GuiMode.EDIT),
                                                            multiSelectHide: false,
                                                            hideStateRegexp: /.*moving.*|.*placing.*/
                                                        }
                                                    },
                                                    "copy_paste": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: editor_2d.CopyPasteController,
                                                        configuration: {
                                                            crossEditorPaste: true
                                                        }
                                                    }
                                                }
                                            },
                                            "handles": {
                                                disabled: (editorMode < GuiMode.EDIT),
                                                controller: editor_2d.HandlesController
                                            },
                                            "snap": {
                                                disabled: (editorMode < GuiMode.EDIT),
                                                controller: editor_2d.SnapController,
                                                configuration : {
                                                    layer: "SNAP"
                                                }
                                            },
                                            "undo_redo": {
                                                disabled: (editorMode < GuiMode.EDIT),
                                                controller: editor_2d.UndoRedoController
                                            },
                                            "origin": {
                                                controller: editor_2d.OriginController,
                                                configuration : {
                                                    grid_value: defaultGridValue,
                                                    grid_thickness: 0.2,
                                                    grid_unit: "",
                                                    grid_show: (editorMode > GuiMode.VIEW),
                                                    origin_show: (editorMode > GuiMode.VIEW),
                                                    units: [''],
                                                    layers: {
                                                        controllayer: "MEASURECONTROL",
                                                        drawinglayer: "MEASURE"
                                                    },
                                                    theme: 'light',
                                                    gridFill: "#DFE3E8",
                                                    gridOriginSize: 10,
                                                    gridSectorFill: "#B4C0CC",
                                                    gridOriginFill: "#34495E",
                                                    gridBackground: "#F4F5F6",
                                                    cantClick: editorMode < GuiMode.EDIT,
                                                    noView: editorMode < GuiMode.VIEW
                                                }
                                            },
                                            "symbolTerminalViewer": {
                                                controller: extensions.SymbolTerminalViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection: ["terminals"]
                                                }
                                            },
                                            "symbolGeneratorViewer": {
                                                controller: extensions.SymbolGeneratorViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection: ["generators"]
                                                }
                                            },
                                            "rectangleViewer": {
                                                controller: editor_2d.RectangleViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"]
                                                }
                                            },
                                            "ellipseViewer": {
                                                controller: editor_2d.EllipseViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"]
                                                }
                                            },
                                            "triangleViewer": {
                                                controller: editor_2d.TriangleViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"]
                                                }
                                            },
                                            "lineViewer": {
                                                controller: editor_2d.LineViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"]
                                                }
                                            },
                                            "textViewer": {
                                                controller: editor_2d.TextViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "TEXT",
                                                        control            : "TEXTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"],
                                                    IMOptions: {
                                                        units: ['pt']
                                                    }
                                                }
                                            },
                                            "propertyViewer": {
                                                controller: extensions.PropertyViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "TEXT",
                                                        control            : "TEXTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"],
                                                    IMOptions: {
                                                        units: ['pt']
                                                    }
                                                }
                                            },
                                            "pathViewer": {
                                                controller: editor_2d.PathViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"]
                                                }
                                            },
                                            "logoViewer": {
                                                controller: editor_2d.LogoViewerController,
                                                configuration : {
                                                    layers: {
                                                        draw               : "ELEMENT",
                                                        control            : "ELEMENTCONTROL",
                                                        interaction        : "INTERACTION",
                                                        interactionControl : "INTERACTIONCONTROL"
                                                    },
                                                    collection : ["shapes"]
                                                }
                                            },
                                            "toolbar": {
                                                disabled: (editorMode < GuiMode.EDIT),
                                                controller : ui_extensions.ToolbarController,
                                                extensions : {
                                                    "symbolTerminalTool": {
                                                        controller: extensions.SymbolTerminalToolController,
                                                        configuration : {
                                                            collection: ["terminals"],
                                                            multiplePlacing: true
                                                        }
                                                    },
                                                    "symbolGeneratorTool": {
                                                        controller: extensions.SymbolGeneratorToolController,
                                                        configuration : {
                                                            collection: ["generators"],
                                                            cTop: 0,
                                                            cBottom: 0,
                                                            cLeft: 4,
                                                            cRight: 4,
                                                            strokeWidth: 2
                                                        }
                                                    },
                                                    "rectangleTool": {
                                                        controller: editor_2d.RectangleToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            angle: 0,
                                                            strokeWidth: 2,
                                                            minWidth: defaultGridValue*2,
                                                            minHeight: defaultGridValue*2
                                                        }
                                                    },
                                                    "ellipseTool": {
                                                        controller: editor_2d.EllipseToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            strokeWidth: 2,
                                                            angle: 0,
                                                            minWidth: defaultGridValue*2,
                                                            minHeight: defaultGridValue*2
                                                        }
                                                    },
                                                    "triangleTool": {
                                                        controller: editor_2d.TriangleToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            strokeWidth: 2,
                                                            angle: 0,
                                                            minWidth: defaultGridValue*2,
                                                            minHeight: defaultGridValue*2
                                                        }
                                                    },
                                                    "lineTool": {
                                                        controller: editor_2d.LineToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            strokeWidth: 2,
                                                            minLength: defaultGridValue*2
                                                        }
                                                    },
                                                    "textTool": {
                                                        controller: editor_2d.TextToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            font: "Verdana",
                                                            fontSize: 10
                                                        }
                                                    },
                                                    "propertyTool": {
                                                        controller: extensions.PropertyToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            fontSize: 10,
                                                            font: "Verdana"
                                                        }
                                                    },
                                                    "pathTool": {
                                                        controller: editor_2d.PathToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            strokeWidth: 2
                                                        }
                                                    },
                                                    "polyLineTool": {
                                                        controller: editor_2d.PolyLineToolController,
                                                        configuration : {
                                                            collection : ["shapes"],
                                                            strokeWidth: 2
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "settings_tab": {
                                disabled: (editorMode < GuiMode.EDIT),
                                name: "settings_tab",
                                controller: ui_extensions.TabController,
                                configuration : {
                                    nameReadOnly: (editorMode < GuiMode.EDIT),
                                    summaryReadOnly: (editorMode < GuiMode.EDIT),
                                    descriptionReadOnly: (editorMode < GuiMode.EDIT),
                                    propertiesReadOnly: (editorMode < GuiMode.LIMITED_EDIT),
                                    button: {
                                        name: 'Settings',
                                        title: '#settings',
                                        style: {
                                            icon: 'icon-settings.svg'
                                        }
                                    }
                                },
                                extensions: {
                                    "settingsForm": {
                                        controller: extensions.SymbolSettingsController,
                                        configuration : {
                                            data: []
                                        }
                                    }
                                }
                            },
                            "avatar_tab": {
                                disabled: (editorMode <= GuiMode.VIEW),
                                name: "avatar_tab",
                                controller: ui_extensions.AvatarController,
                                configuration : {
                                    userUrl: endpoints['accounts']
                                }
                            }
                        }
                    }
                }
            }
        }
    };

    return config;

};

module.exports = SymbolEditorApp;

if(typeof window !== 'undefined'){
    window["SymbolEditorApp"] = SymbolEditorApp;
}
